import React, { useEffect, useState,useRef, useCallback }  from 'react'
import {  useDispatch, useSelector } from 'react-redux'
import { useUpdateEffect } from '../../../hooks'
import { CopyActorDetails, UpdateActorCopyStatus } from '../../actions'
import { useActor } from '../../hooks/useActor'

 const CopyActorLogic=({renderProps,actorType})=>{
    const timeoutRef = useRef()
    const dispatch=useDispatch()
    const [activeState,setActiveState]=useState('')
    const { saveActorDetails }=useActor()
    const AllActorDetails=useSelector((state)=>state.Actor)  
    const copiedActorStatus=useSelector((state)=>state.Actor[`copyTo${actorType}`]) //{actorname:true,actorName:false}
    const copyFromActorDetail=useSelector((state)=>state.Actor[`${actorType}`]) // details of copyFrom Actor
    useEffect(()=>{
        if(activeState){
            AllActorDetails[activeState].actorType=activeState
            saveActorDetails(AllActorDetails[activeState])
        }
    },[activeState])

    useUpdateEffect(()=>{
        clearTimeout(timeoutRef.current)
        timeoutRef.current = setTimeout(() => {
                for(let [key,value] of Object.entries(copiedActorStatus)){
                 if(value){ 
                AllActorDetails[key].actorType=key
                saveActorDetails(AllActorDetails[activeState])
                 }
             }
            dispatch(CopyActorDetails(actorType,""))
        }, 300)
    },[copyFromActorDetail,actorType])
    
    const copyActorDetails=useCallback((e,data)=>{
        const {name,checked}=data
        dispatch(UpdateActorCopyStatus(actorType,name,checked))
        setActiveState(checked ? name :"")

    },[actorType])
    useEffect(()=>{
        return () => {
            clearTimeout(timeoutRef.current)
        }
      },[])

    return (
        renderProps({setActiveState,copiedActorStatus,copyActorDetails})
     )
   
   
  }
  
  export default CopyActorLogic

